<template>
  <div>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link :to="{name: 'account-journeys', params: {id: accountId}}">
              {{ $t('journey.detailsView.backLinkLabel') }}
            </router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page"> {{ journeyId }}</li>
        </ol>
      </nav>
    </div>
    <div>

    </div>

    <div>
      <card>
        <template slot="header">
          <h4 class="card-title d-inline">{{ $t('journey.detailsView.title') }}</h4>
        </template>
        <template>
          <div v-loading="loading">
            <card v-if="data">
              <journey-details :details="data" :with-taps="true"/>
            </card>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import JourneyDetails from 'src/components/Journey/JourneyDetails'
import {mapActions, mapState} from "vuex";

export default {
  name: "AccountJourney",
  components: {
    JourneyDetails,
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    journeyId: {
      type: String,
      required: true
    },
  },
  methods: {
    ...mapActions(['LoadAccountJourney']),
  },
  mounted() {
    // Loading user top-up data
    this.LoadAccountJourney({accountID: this.accountId, journeyID: this.journeyId});
  },
  computed: {
    ...mapState({
      // darkTheme: state => state.app.darkMode,
      loading: state => state.account_journey.loading,
      data: state => state.account_journey.data,
    }),
  },
}
</script>

